module.exports = __webpack_public_path__ + "static/media/rhino_fda_pilot.2ceb7dbe.mp4";